import React from 'react';
import { CallLogPanel } from '@/components/calls/CallLogPanel';

export default function CallsPage() {
  return (
    <div className="w-full p-4 md:p-6 max-w-6xl mx-auto space-y-3" data-testid="calls-page">
      <div>
        <h1 className="font-heading text-2xl font-bold text-stone-900">Call Log</h1>
        <p className="text-sm text-stone-500">Every AI call with date, time, duration, full recording, transcript, summary and any appointment booked.</p>
      </div>
      <CallLogPanel />
    </div>
  );
}
